import { gidToId } from '@shared/shop-api/core/helper'
import { getMetafieldString } from '@shared/shop-api/metafield/mapper'
import type { InfoPageFragment } from '@shared/types/storefront/graphql'

export const toInfoPage = (page: InfoPageFragment) => {
  return {
    id: gidToId(page.id),
    title: page.title.replace(/^search/i, '').trim(),
    contentfulId: getMetafieldString(page.metafields, 'contentful_id'),
    handle: page.handle,
  }
}
